import styled from 'styled-components';

export const FareOptionsContainer = styled.div`
  width: 100%;
  flex-grow: 0;
  margin: 0 0 10px 0;
  padding: 10px 15px;
  border-radius: 2px;
  background-image: linear-gradient(90deg, #43e1a8 0%, #2274e0 100%);
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 2px 4px 0px;
  border-radius: 10px;
`;

export const FareOptionHeading = styled.div`
  margin-bottom: 16px;
  h2 {
    font-weight: 900;
    color: #ffffff;
    margin: 0;
    padding: 0;
  }
`;

export const FareOptionListWrapper = styled.div``;

export const FareOptionList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const FareOptionListElement = styled.li(
  props => `
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 8px 12px;
    border-radius: 2px;
    box-shadow: 0 1px 7px 0 rgb(0 0 0 / 20%);
    background-color: ${props.selected ? '#2274e0' : '#ffffff'};
    
    
    font-weight: 900;
    line-height: 1.33;
    text-align: center;
    color: ${props.selected ? '#ffffff' : '#4a4a4a'};
    margin-right: 16px;
    cursor: pointer;
    &:hover{
      color: #ffffff;
      background-color: #2274e0;
    }
  `
);

export const ImpInfo = styled.span`
  text-align: right;
  color: #ffffff;
  position: absolute;
  right: 24px;
  top: 20px;
  width: 60%;
`;
